
let inject = [
  '$scope',
  'PaymentBillsService',
  '$state',
  '$rootScope',
  'SharedService',
  '$timeout',
  'ngAuthSettings',
  'SessionService',
  'NgTableParams',
  '$uibModal',
  'ServiceOrdersService',
  '$window'
];
class PaymentBillsController {
  constructor($scope,
    PaymentBillsService,
    $state,
    $rootScope,
    SharedService,
    $timeout,
    ngAuthSettings,
    SessionService,
    NgTableParams,
    $uibModal,
    ServiceOrdersService,
    $window) {

    this.$state = $state;
    this.SessionService = SessionService;
    this.ngAuthSettings = ngAuthSettings;
    this.NgTableParams = NgTableParams;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.PaymentBillsService = PaymentBillsService;
    this.$uibModal = $uibModal;
    this.SharedService = SharedService;
    this.ServiceOrdersService = ServiceOrdersService;
    this.store = $window.localStorage;



    /*    this.loanding = false;
        this.payment = {};
        this.billfoldResume = null;
        this.tab = 1;
        this.getTableHeight = 'height: 30px';
        this.bills = [];*/
    this.urlPay = this.ngAuthSettings.config.env.apiEndPoint + '/recaudos/recaudos/pay-gate';
    ////////////////////////////////////////////
    this.serviceOrdersList = null;
    this.stateServiceOrders = {};
    this.ngTableConfigServiceOrders = null;
    this.ngTableColsServiceOrders = null;

    this.serviceOrderDetail = null;
    this.stateServiceOrderDetail = {};
    this.ngTableConfigServiceOrderDetail = null;
    this.ngTableColsServiceOrderDetail = null;

    this.wachingDetailServiceOrder = false;

    this.payment = {};
    this.payment.recaudo = 0;
    this.payment.recaudo_total = 0;
    this.payCart = [];
    this.globals = null;
    this.notification = false;
  }

  $onInit() {
    this.globals = this.shCtrl.globals;
    this.getServiceOrdersHead();
  }

  //////////////////////////////////////////////////////////////////


 

  getServiceOrdersHead() {

    this.stateServiceOrders.loading = true;
    this.wachingDetailServiceOrder = false;

    this.$timeout(() => {
      if (this.serviceOrdersList && this.serviceOrdersList.length > 0) {
        this.stateServiceOrders.loading = false;
        this.stateServiceOrders.loaded = true;
      } else {

        this.shCtrl.globals.currentUser.thirdDocumentNumber
        this.PaymentBillsService.getItemsToFact(this.shCtrl.globals.currentUser.thirdDocumentNumber).then(response => {
          this.stateServiceOrders.loading = false;
          this.stateServiceOrders.loaded = true;
          this.serviceOrdersList = response;

          this.serviceOrdersList.forEach((value, index) => {
            value.saldo_documento = value.detalle_saldo_documento;
            value.valor_doc = parseInt(value.detalle_valor_documento);
            value.valor_pendiente = parseInt(value.detalle_valor_documento);
            value.valor_pagar_hoy = 0;
            value.valor_pagar_hoy_before = 0;
            this.payment.recaudo += value.valor_pendiente;
            value.type = "Factura";

            this.shCtrl.globals.currentClient.payCart.forEach(val => {
              if (value.type == "Factura") {
                if (value.detalle_numero_documento == val.detalle_numero_documento) {
                  value.activate = true;
                  value.valor_pagar_hoy = val.valor_pagar_hoy;
                  value.valor_pagar_hoy_before = val.valor_pagar_hoy_before;
                  value.valor_pendiente = val.valor_pendiente;
                  value.detalle_saldo_documento = val.detalle_saldo_documento;
                  this.payment.recaudo_total += val.valor_pagar_hoy;
                }
              }
            });
          })
          //this.serviceOrdersList = cabeceraData;
          this.initNgTableServiceOrders();
        }).catch((reason) => {
          this.stateServiceOrders.loading = false;
          this.stateServiceOrders.loaded = true;
          this.stateServiceOrders.error = true;
        });
      }

      console.log(this.stateServiceOrders);
      console.log(this.wachingDetailServiceOrder);

    }, 1000);
  }

  initNgTableServiceOrders() {
    /**
     * name:                           "NCN-000024"
     * type:                             "Lorem Ipsum"
     * fecha_cotizacion:                 "2016-09-14"
     * validez_cotizacion:               "2016-09-14"
     * assigned_user_name:               "Lorem Ipsum"
     * valor_saldo:                      "0.0000"
     * valor_pendiente:                  "0.0000"
     * valor_pagar_hoy:                  "0.0000"
     * total:                            "0.0000"
     */
    this.ngTableColsServiceOrders = [
      {
        field: "detalle_numero_documento",
        title: "No.",
        // sortable: "detalle_numero_documento",
        filter: { "detalle_numero_documento": "text" },
        show: true
      },
      {
        field: "detalle_fecha_documento",
        title: "Fecha Emisión",
        // sortable: "detalle_fecha_documento",
        filter: { "detalle_fecha_documento": "text" },
        show: true
      },
      {
        field: "detalle_fecha_vencimiento",
        title: "Fecha Vencimiento",
        // sortable: "detalle_fecha_vencimiento",
        filter: { "detalle_fecha_vencimiento": "text" },
        show: true
      },
      {
        field: "detalle_valor_documento",
        title: "Vr. total doc.",
        // sortable: "detalle_valor_documento",
        filter: { "detalle_valor_documento": "text" },
        show: true
      },
      {
        field: "saldo_documento",
        title: "Vr. Pte. por pagar",
         // sortable: "saldo_documento",
         filter: { "saldo_documento": "text" },
        show: true
      },
      {
        field: "valor_pagar_hoy",
        title: "Vr. a pagar hoy",
        filter: { "valor_pagar_hoy": "text" },
        show: true
      },
      {
        field: "selection",
        title: "Seleccionar",
        filter: { "selection": "text" },
        show: true
      },
      {
        field: "detalle_saldo_documento",
        title: "Vr. pte. x pagar hoy",
        filter: { "detalle_saldo_documento": "text" },
        // // sortable: "detalle_saldo_documento",
        // filter: { "detalle_saldo_documento": "text" },
        show: true
      }
    ];

    let initialParams = {
      count: 20
    };

    let initialSettings = {
      counts: [10, 20, 50],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.serviceOrdersList
    };

    this.ngTableConfigServiceOrders = new this.NgTableParams(initialParams, initialSettings);
  }

  activateServiceOrder(row) {
    if (row.activate) {
      row.valor_pagar_hoy = row.valor_pendiente;
      row.valor_pagar_hoy_before = row.valor_pendiente;
      this.payment.recaudo_total += row.valor_pendiente;
      row.detalle_saldo_documento = (row.detalle_valor_documento - row.valor_pagar_hoy);
    } else {
      this.payment.recaudo_total -= row.valor_pagar_hoy_before;
      row.valor_pagar_hoy = 0;
      row.valor_pagar_hoy_before = 0;
      row.detalle_saldo_documento = row.detalle_valor_documento;
    }

  }

  changeValor(row) {
    let valorServiceOrder = parseInt(row.valor_pagar_hoy.replace(/,/g, ''));
    if (valorServiceOrder > row.valor_pendiente) {
      row.valor_pagar_hoy = row.valor_pendiente;
      valorServiceOrder = row.valor_pendiente;
    }
    this.payment.recaudo_total -= row.valor_pagar_hoy_before;
    this.payment.recaudo_total += valorServiceOrder;

    row.detalle_saldo_documento = (row.detalle_valor_documento - valorServiceOrder);
    row.valor_pagar_hoy_before = valorServiceOrder;
    row.valor_pagar_hoy = parseInt(row.valor_pagar_hoy.replace(/,/g, ''));

  }

  addPayment() {
    let result = angular.copy(this.serviceOrdersList.filter(val => { return val.activate; }));
    let globalsData = angular.copy(this.shCtrl.globals);
    if (result.length) {
      result.forEach(val => {
        globalsData.currentUser.payCart.forEach((value, key) => {
          if (val.detalle_numero_documento == value.detalle_numero_documento) {
            globalsData.currentUser.payCart.splice(key, 1);
          }
        });
      });
      globalsData.currentUser.totalCartPay = this.payment.recaudo_total;
      globalsData.currentUser.payCart.forEach(val => {
        result.push(val);
        globalsData.currentUser.totalCartPay += val.valor_pagar_hoy;
      });
      // globalsData.currentUser.payCart = result;
      this.shCtrl.globals.currentUser.payCart = result
      this.shCtrl.globals.currentUser.totalCartPay = globalsData.currentUser.totalCartPay;
      this.SessionService.put('globals', this.shCtrl.globals);
      // this.payment.recaudo_total = 0
      angular.copy(this.shCtrl.globals.currentUser, this.shCtrl.globals.currentClient);
      this.notification = true;
      this.$timeout(() => {
        // this.shCtrl.globals.currentUser.activeTap = 3;
        this.notification = false;
      }, 3000);
    } else {
      alert('Debe seleccionar al menos una factura a pagar');
    }
  }


}

PaymentBillsController.$inject = inject;

export default PaymentBillsController;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/payments-advances/payment-bills/payment-bills.controller.js
 **/